
import Events from './Events.js'

let _dataLayerInstance = null
export default function () {
  if (_dataLayerInstance !== null) {
    return _dataLayerInstance
  }

  const events = new Events()

  _dataLayerInstance = {
    methodsToBeExposed: {
      ...events.getExposedMethods()
    }
  }

  return _dataLayerInstance
}




// WEBPACK FOOTER //
// ./src/plugins/gtm/datalayer/index.js